import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { useEditarConfigDeEnvelopeContext } from "../..";
import UnForm from "../../../../../../Components/Form";
import OrSpinner from "../../../../../../Components/Utils/OrSpinner";
import {
    AtualizarConfigEnvelopeController,
    GetConfigEnvelopeController,
} from "../../../../../../Controllers/Geral/ConfigEnvelope/ConfigEnvelopeControllers";
import useAsyncCallback from "../../../../../../hooks/useAsyncCallback";
import useAsyncEffect from "../../../../../../hooks/useAsyncEffect";

interface IEditarNomeConfigEnvelopeProps {}

interface IEditarNomeConfigEnvelopeFormData {
    DS_CONFIG_ENVELOPE_DOCUMENTO: string;
}

export default function EditarNomeConfigEnvelope(
    props: IEditarNomeConfigEnvelopeProps
) {
    const { idConfigEnvelope, updateList } = useEditarConfigDeEnvelopeContext();
    const {
        value: dadosConfigEnvelope,
        loading,
        execute: updateDadosConfig,
    } = useAsyncEffect(
        () => GetConfigEnvelopeController(idConfigEnvelope),
        [idConfigEnvelope]
    );

    const { execute: handleEditarNomeConfigEnvelopeSubmit, loading: editando } =
        useAsyncCallback(
            async (formData: IEditarNomeConfigEnvelopeFormData) => {
                if (dadosConfigEnvelope) {
                    await AtualizarConfigEnvelopeController({
                        DS_ENVELOPE: formData.DS_CONFIG_ENVELOPE_DOCUMENTO,
                        ID_ENVELOPE_DOCUSIGN_CONFIG: idConfigEnvelope,
                        ID_PRODUTO: dadosConfigEnvelope.ID_PRODUTO,
                    })
                        .then(updateList)
                        .then(updateDadosConfig);
                }
            }
        );

    return (
        <UnForm
            handleSubmit={handleEditarNomeConfigEnvelopeSubmit}
            className="row align-items-end"
        >
            <OrSpinner
                loading={loading}
                wrapperLoadingClasses="text-center w-100"
            >
                <UnForm.Input
                    name="DS_CONFIG_ENVELOPE_DOCUMENTO"
                    wrapperClassName="col-9 col-sm-10"
                    defaultValue={dadosConfigEnvelope?.DS_ENVELOPE}
                    label="Nome"
                />
                <UnForm.SubmitButton
                    loading={editando}
                    loadingSize="sm"
                    color="primary"
                    wrapperClassName="col-3 col-sm-2"
                    clearClasses
                    className=" d-block"
                    icon={faEdit}
                />
            </OrSpinner>
        </UnForm>
    );
}
